import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core';
import ProjectLinks from 'src/app/common/project.links';
import { SessionService } from '../../../auth/session.service';
import AppSettings from '../../../common/app.settings';
import { CardInfoType } from '../../../components/profile/profile.enum';
import { getStatusBadgeStyle } from '../../../const/entity-view-constants';
import {
  ActionBtnInfo,
  CardContentWithBtnInfo,
  CardModel,
  EntityStatus,
  ItemStatus,
} from '../../../interfaces/views.interface';
import { AccountStatus, UserRelationToGroup } from '../../../swagger-api';

// TODO: refactor card component. Make component domain agnostic.
// take the UICard interface as a basis.

@Component({
  selector: 'app-basic-card',
  templateUrl: './basic-card.component.html',
  styleUrls: ['./basic-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BasicCardComponent implements CardContentWithBtnInfo {
  @Input({ required: true }) public card: CardModel;
  @Input({ required: true }) public index: number;
  @Input({ required: true }) public status: EntityStatus;

  @Input({ required: false }) public actionDisabled = false;

  @Output() public action: EventEmitter<ActionBtnInfo> = new EventEmitter<ActionBtnInfo>();

  public readonly DELETED: EntityStatus = ItemStatus.DELETED;
  public readonly infoType: typeof CardInfoType = CardInfoType;
  public readonly AppSettings: typeof AppSettings = AppSettings;

  private sessionService = inject(SessionService);

  /**
   * @description Calls on action button click and emits action event. Now it's used only
   *              for post card and user card for invitation to project/community.
   */
  public onAction(index: number): void {
    this.action.emit({ actionBtnId: this.card.actionBtnId, dataTestId: `card-action-button_${index}` });
  }

  public get isMember(): boolean {
    return this.card.badge === UserRelationToGroup.Member;
  }

  public get isLeader(): boolean {
    return this.card.badge === UserRelationToGroup.Leader;
  }

  public get isAdminSession(): boolean {
    return this.sessionService.isAdminSession();
  }

  public getLink(): string {
    if (
      this.card.status === AccountStatus.ACTIVE ||
      this.card.status === ItemStatus.BLOCKED ||
      (this.card.status === AccountStatus.DEACTIVATED && this.isAdminSession)
    ) {
      return `${ProjectLinks.LINK_PROFILE_VIEW}/${this.card.id}`;
    } else {
      return '';
    }
  }

  public getBadgeStyle(): string {
    return getStatusBadgeStyle(this.card?.status);
  }
}
